import { environment } from '../../../../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HandleError, HttpErrorHandler } from 'src/app/shared/services/handle-error.service';
import { RequestCRUD } from 'src/app/shared/services/abstract/request-crud.service';
import { ResponseServiceModel } from 'src/app/shared/models/response-service.model';
import { Observable } from 'rxjs';
import { AyudasEntry } from 'src/app/shared/entrys/ayudas.entry';
import { Ayudas } from 'src/app/shared/enumeraciones/ayudas.enum';
import { TipoRnt } from 'src/app/shared/enumeraciones/tipo-rnt.enum';
import { retry } from 'rxjs/operators';
import { EstadosRnt } from 'src/app/shared/enumeraciones/estados-rnt.enum';
import { EstadosSolicitud } from 'src/app/shared/enumeraciones/estados-solicitud.enum';
import { TipoSolicitud } from 'src/app/shared/enumeraciones/tipo-solicitud.enum';
import { EnviromentGlobalService } from 'src/app/shared/services/enviroment-global.service';
import { CompletaInformacionPlataformas } from '../../../core/containers/bandeja-principal/prestador/pasos/completa-informacion-plataformas/completa-informacion-plataformas.component';

@Injectable()
export class AyudasService implements RequestCRUD<AyudasEntry, ResponseServiceModel> {
	private API_URL;
	constructor(httpErrorHandler: HttpErrorHandler, private http: HttpClient, private enviromentGlobalService: EnviromentGlobalService) {
		this.API_URL = enviromentGlobalService.apiUrl;
	}

	get(entry: AyudasEntry): Observable<ResponseServiceModel> {
		return this.http.post<ResponseServiceModel>(`${this.API_URL}/AyudaInterfaz/ObtenerConfiguracion`, entry).pipe(
			retry(2)
		);
	}

	update(entry: AyudasEntry): Observable<ResponseServiceModel> {
		throw new Error('Method not implemented.');
	}
	create(entry: AyudasEntry): Observable<ResponseServiceModel> {
		throw new Error('Method not implemented.');
	}
	delete(entry: AyudasEntry): Observable<ResponseServiceModel> {
		throw new Error('Method not implemented.');
	}
	// Principales
	get establecimiento() {
		return {
			tipo_rnt_id: 0,
			identificador_interfaz: Ayudas.BandejaPrestador,
			tipo_solicitud_id: 0,
			estado_rnt_id: 0,
			estado_solicitud_id: 0
		} as AyudasEntry;
	}
	get notificaciones() {
		return {
			tipo_rnt_id: 0,
			identificador_interfaz: Ayudas.Notificaciones,
			tipo_solicitud_id: 0,
			estado_rnt_id: 0,
			estado_solicitud_id: 0
		} as AyudasEntry;
	}
	get detalleSolicitud() {
		return {
			tipo_rnt_id: 0,
			identificador_interfaz: Ayudas.DetalleSolicitud,
			tipo_solicitud_id: 0,
			estado_rnt_id: 0,
			estado_solicitud_id: 0
		} as AyudasEntry;
	}
	get arredatario() {
		return {
			tipo_rnt_id: 0,
			identificador_interfaz: Ayudas.Arrendatario,
			tipo_solicitud_id: 0,
			estado_rnt_id: 0,
			estado_solicitud_id: 0
		} as AyudasEntry;
	}

	// Bandeja estados rnt

	estadoRntBandejaPrestador({estado_rnt_id,
								sub_categoria_id,
								tipo_rnt_id,
								tipo_solicitud_id,
								estado_solicitud_id}:AyudasEntry
							) {
		return {tipo_rnt_id,
				identificador_interfaz: Ayudas.BandejaPrestador,
				tipo_solicitud_id,
				estado_rnt_id: estado_rnt_id,
				estado_solicitud_id,
				sub_categoria_id} as AyudasEntry;
	}

	// Bandeja estados Solicitud

	estadoSolicitudBandejaPrestador(estado_solicitud_id: EstadosSolicitud) {
		return {
			tipo_rnt_id: 0,
			identificador_interfaz: Ayudas.BandejaPrestador,
			tipo_solicitud_id: 0,
			estado_rnt_id: 0,
			estado_solicitud_id: estado_solicitud_id
		} as AyudasEntry;
	}

	// Pasos
	completaInformacionEstablecimiento(
		tipo_solicitud: TipoSolicitud,
		sub_categoria_id: number,
		estado_rnt_id: number,
		estado_solicitud_id: number) {
		return {
			tipo_rnt_id: TipoRnt.Establecimiento,
			identificador_interfaz: Ayudas.CompletaInformacionEstablecimineto,
			tipo_solicitud_id: tipo_solicitud,
			estado_rnt_id,
			estado_solicitud_id,
			sub_categoria_id,
		} as AyudasEntry;
	}

	completaInformacionInmueble(
		tipo_solicitud: TipoSolicitud,
		sub_categoria_id: number,
		estado_rnt_id: number,
		estado_solicitud_id:number) {
		return {
			tipo_rnt_id: TipoRnt.Inmuebles,
			identificador_interfaz: Ayudas.CompletaInformacionInmueble,
			tipo_solicitud_id: tipo_solicitud,
			estado_rnt_id,
			estado_solicitud_id,
			sub_categoria_id 
		} as AyudasEntry;
	}
	completaInformacionPlataformas(
		tipo_solicitud: TipoSolicitud,
		sub_categoria_id: number,
		estado_rnt_id: number,
		estado_solicitud_id:number) {
		return {
			tipo_rnt_id: TipoRnt.PlataformaDigitales,
			identificador_interfaz: Ayudas.CompletaInformacionPlataformas,
			tipo_solicitud_id: tipo_solicitud,
			estado_rnt_id,
			estado_solicitud_id,
			sub_categoria_id 
		} as AyudasEntry;
	}
	completaInformacionGuia(
		tipo_solicitud		: TipoSolicitud,
		sub_categoria_id	: number,
		estado_rnt_id		: number,
		estado_solicitud_id	: number
	) {
		return {
			tipo_rnt_id: TipoRnt.Guia,
			identificador_interfaz: Ayudas.CompletaInformacionGuia,
			tipo_solicitud_id: tipo_solicitud,
			estado_rnt_id,
			estado_solicitud_id,
			sub_categoria_id
		} as AyudasEntry;
	}

	capacidad(
		tipo_solicitud		: TipoSolicitud, 
		tipo_rnt			: TipoRnt,
		sub_categoria_id	: number,
		estado_rnt_id 		: number,
		estado_solicitud_id	: number
	) {
		return {
			tipo_rnt_id: tipo_rnt,
			identificador_interfaz: Ayudas.Capacidad,
			tipo_solicitud_id: tipo_solicitud,
			estado_rnt_id,
			estado_solicitud_id,
			sub_categoria_id
		} as AyudasEntry;
	}

	datosAdicionales(
		tipo_solicitud		: TipoSolicitud, 
		tipo_rnt			: TipoRnt,
		sub_categoria_id	: number,
		estado_rnt_id		: number,
		estado_solicitud_id	: number
	) {
		return {
			tipo_rnt_id: tipo_rnt,
			identificador_interfaz: Ayudas.TipoEstablecimiento,
			tipo_solicitud_id: tipo_solicitud,
			estado_rnt_id,
			estado_solicitud_id,
			sub_categoria_id
		} as AyudasEntry;
	}

	codigoConducta(
		tipo_solicitud		: TipoSolicitud, 
		tipo_rnt			: TipoRnt,
		sub_categoria_id	: number,
		estado_rnt_id		: number,
		estado_solicitud_id	: number
	) {
		return {
			tipo_rnt_id: tipo_rnt,
			identificador_interfaz: Ayudas.CodigoConducta,
			tipo_solicitud_id: tipo_solicitud,
			estado_rnt_id,
			estado_solicitud_id,
			sub_categoria_id
		} as AyudasEntry;
	}

	fontur(
		tipo_solicitud		: TipoSolicitud, 
		tipo_rnt			: TipoRnt,
		sub_categoria_id	: number,
		estado_rnt_id		: number,
		estado_solicitud_id	: number
		) {
		return {
			tipo_rnt_id: tipo_rnt,
			identificador_interfaz: Ayudas.Fontur,
			tipo_solicitud_id: tipo_solicitud,
			estado_rnt_id,
			estado_solicitud_id,
			sub_categoria_id
		} as AyudasEntry;
	}

	pagoParafiscal(
		tipo_solicitud		: TipoSolicitud, 
		tipo_rnt			: TipoRnt,
		sub_categoria_id	: number,
		estado_rnt_id		: number,
		estado_solicitud_id	: number
	) {
		return {
			tipo_rnt_id: tipo_rnt,
			identificador_interfaz: Ayudas.PagoParafiscal,
			tipo_solicitud_id: tipo_solicitud,
			estado_rnt_id,
			estado_solicitud_id,
			sub_categoria_id
		} as AyudasEntry;
	}

	encuesta(
		tipo_solicitud		: TipoSolicitud, 
		tipo_rnt			: TipoRnt,
		sub_categoria_id	: number,
		estado_rnt_id		: number,
		estado_solicitud_id	: number
	) {
		return {
			tipo_rnt_id				: tipo_rnt,
			identificador_interfaz	: Ayudas.Encuesta,
			tipo_solicitud_id		: tipo_solicitud,
			estado_rnt_id,
			estado_solicitud_id,
			sub_categoria_id
		} as AyudasEntry;
	}
	otrasSolicitudes(
		tipo_solicitud		: TipoSolicitud, 
		tipo_rnt			: TipoRnt,
		estado_rnt_id		: number,
		estado_solicitud_id	: number,
		sub_categoria_id	: number
	) {
		return {
			tipo_rnt_id: tipo_rnt,
			identificador_interfaz: Ayudas.OtrasSolicitudes,
			tipo_solicitud_id: tipo_solicitud,
			estado_rnt_id,
			estado_solicitud_id,
			sub_categoria_id
		} as AyudasEntry;
	}
}
